import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { formatLocalDateOnly } from '../../utils/generalFunctions';

import { setAlert } from '../../actions/alert';
import { obtenerCita, editarCita, buscarAsesores, buscarHorariosCita } from '../../actions/psicologica';

const EditarCita = ({ cita, reestablecerCita }) => {

    const dispatch =  useDispatch();

    const { detalles_cita, listado_asesores, listado_horarios_cita } = useSelector(state => state.psicologica);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [citaData, setCitaData] = useState({
        id: null, 
        id_asesor: null,
        fecha: null,
        hora_inicio: null,
        hora_fin: null,
        observaciones: null
    });

    const [asesorData, setAsesorData] = useState(null);
    const [asesoresFilter, setAsesoresFilter] = useState([]);

    const [horarioData, setHorarioData] = useState(null);
    const [horariosFilter, setHorariosFilter] = useState([]);

    /* Editar cita */
    const handleSelectAsesor = (option) => {
        setAsesorData(option);

        setCitaData({
            ...citaData,
            id_asesor: option != null ? option.value : null, 
            hora_inicio: null,
            hora_fin: null
        });

        setHorarioData(null);

        if(citaData.fecha){
            dispatch(buscarHorariosCita(citaData.id, option?.value || null, formatLocalDateOnly(citaData.fecha)));
        }else{
            setHorariosFilter([]);
        }
    }

    const handleDatePicker = (name, value) => {
        setCitaData({
            ...citaData,
            [name]: value, 
            hora_inicio: null,
            hora_fin: null
        });

        setHorarioData(null);

        if(value){
            dispatch(buscarHorariosCita(citaData.id, asesorData?.value || null, formatLocalDateOnly(value)));
        }else{
            setHorariosFilter([]);
        }
    }

    const handleSelectHorario = (option) => {
        setHorarioData(option);

        setCitaData({
            ...citaData,
            hora_inicio: option != null ? option.hora_inicio : null,
            hora_fin: option != null ? option.hora_fin : null
        });
    }

    const handleInputChange = ({ target }) => {
        setCitaData({
            ...citaData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(citaData.id_asesor){
            if(citaData.fecha){
                if(citaData.hora_inicio <= citaData.hora_fin && (citaData.hora_inicio && citaData.hora_fin)){
                    const fechaLocal = new Date(citaData.fecha);
                    fechaLocal.setHours(0,0,0,0);
                    citaData.fecha = fechaLocal.toISOString();
                    
                    await setStatusProcesar(true);
                    await dispatch(editarCita(citaData));
                    await handleCerrar();
                    await setStatusProcesar(false);
                }else{
                    await dispatch(setAlert('La hora de inicio debe ser menor o igual a la de finalización', 'danger'));
                }
            }else{
                await dispatch(setAlert('La fecha de la cita es requerida', 'danger'));
            }
        }else{
            await dispatch(setAlert('Ingresa el asesor al que se le reservara', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setCitaData({
                id: null, 
                fecha: null,
                hora_inicio: null,
                hora_fin: null,
                observaciones: null
            });

            setHorarioData(null);
            setEditarModal(false);
            reestablecerCita(null);
        }
    }

    useEffect(() => {
        dispatch(obtenerCita(null));
    }, []);

    useEffect(() => {
        if(cita){
            setEditarModal(true);

            dispatch(obtenerCita(cita?.id));

            dispatch(buscarAsesores());

            setCitaData({
                ...citaData, 
                id: cita?.id
            });
        }        
    }, [cita]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_asesores.length; i++) {
            options.push({ value: listado_asesores[i]._id, label: [listado_asesores[i].nombre, listado_asesores[i].apellido_paterno, listado_asesores[i].apellido_materno].join(' ') });
        }

        setAsesoresFilter(options);
    }, [listado_asesores]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_horarios_cita.length; i++) {
            if([listado_horarios_cita[i].hora_inicio, listado_horarios_cita[i].hora_fin].join(' - ') === String(detalles_cita?.horario_elegido)){
                setHorarioData({value: i, label: [listado_horarios_cita[i].hora_inicio, listado_horarios_cita[i].hora_fin].join(' - '), hora_inicio: listado_horarios_cita[i].hora_inicio, hora_fin: listado_horarios_cita[i].hora_fin });

                setCitaData({
                    ...citaData,
                    hora_inicio: listado_horarios_cita[i].hora_inicio,
                    hora_fin: listado_horarios_cita[i].hora_fin
                });
            }

            options.push({ value: i, label: [listado_horarios_cita[i].hora_inicio, listado_horarios_cita[i].hora_fin].join(' - '), hora_inicio: listado_horarios_cita[i].hora_inicio, hora_fin: listado_horarios_cita[i].hora_fin });
        }

        setHorariosFilter(options);
    }, [listado_horarios_cita]);

    useEffect(() => {
        if(detalles_cita && cita){
            setCitaData({
                ...citaData, 
                id: detalles_cita?._id || null,
                id_asesor: detalles_cita?.usuario?._id || null,
                fecha: detalles_cita?.fecha_inicio || null,
                hora_inicio: detalles_cita?.hora_inicio || null,
                hora_fin: detalles_cita?.hora_fin || null,
                observaciones: detalles_cita?.observaciones || null
            });

            setAsesorData(
                detalles_cita?.usuario?._id ? 
                    { value: detalles_cita?.usuario?._id, label: detalles_cita?.usuario?.nombre + ' ' + detalles_cita?.usuario?.apellido_paterno + ' ' + detalles_cita?.usuario?.apellido_materno }
                :
                    null
            );

            dispatch(buscarHorariosCita(detalles_cita?._id, detalles_cita?.usuario?._id || null, formatLocalDateOnly(detalles_cita?.fecha_inicio)));
    
            if(horariosFilter.length > 0){
                let horario_elegido = horariosFilter.find( horario => String(horario.label) === String(detalles_cita?.horario_elegido) );
    
                if(horario_elegido){
                    setHorarioData({value: horario_elegido.value, label: horario_elegido.label, hora_inicio: horario_elegido.hora_inicio, hora_fin: horario_elegido.hora_fin});
                }
            }
        }
    }, [detalles_cita]);

    return (
        <Modal show={editarModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar cita</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-5 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_asesor"
                                name="id_asesor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar asesor"
                                isClearable
                                options={asesoresFilter}
                                value={asesorData}
                                onChange={(value) => handleSelectAsesor(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha"
                                    name="fecha"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    selected={ citaData.fecha != null ? new Date(citaData.fecha) : '' }
                                    onChange={ date => handleDatePicker('fecha', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="horario"
                                name="horario"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar horario"
                                isClearable
                                options={horariosFilter}
                                value={horarioData}
                                onChange={(value) => handleSelectHorario(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control textareCampo" placeholder="Observaciones" id="observaciones" name="observaciones" value={citaData.observaciones} onChange={e => handleInputChange(e)}></textarea>
                                <label htmlFor="observaciones">Observaciones</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Editar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Editar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarCita;